import styled from "styled-components";
import { toVWDesktop, toVWMobile, vwDesktop, vwMobile } from "../../helpers/styles";
import { BREAKPOINTS } from "../../helpers/theme";

export const Container = styled.div<{ backgroundColor?: string, color?: string }>`
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.backgroundColor};
  color: ${(props) => props.color};

  direction: ltr;
  padding: ${toVWMobile(44)}vw ${toVWMobile(0)}vw;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    flex-direction: row;
    padding: ${toVWDesktop(80)}vw ${toVWDesktop(100)}vw;
    padding-right: 0;
    gap: ${toVWDesktop(64)}vw;
  }
`;


export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: ${toVWMobile(16)}vw;
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-inline: 0;
    flex:100;
    max-width: ${toVWDesktop(520)}vw;
    justify-content: center;
  }
`;

export const ArrowsContainer = styled.div`
  display: flex;
  gap: ${toVWMobile(24)}vw;
  
  
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    gap: ${toVWDesktop(24)}vw;
  }
`;

export const Title = styled.h2`
  font-size: ${toVWMobile(32)}vw;
  font-weight: 900;
  line-height: 94%;
  letter-spacing: ${toVWMobile(0.96)}vw;
  text-transform: uppercase;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    font-size: ${toVWDesktop(56)}vw;
    letter-spacing: ${toVWDesktop(2.24)}vw;
  }
`;


export const Subtitle = styled.p`
  font-size: ${toVWMobile(18)}vw;
  line-height: 140%;
  font-weight: 600;
  margin-top: ${toVWMobile(8)}vw;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    font-size: ${toVWDesktop(18)}vw;
    margin-top: ${toVWDesktop(12)}vw;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  background-color: var(--color-white);
  align-items: center;
  justify-content: center;
  width: ${toVWMobile(44)}vw;
  height: ${toVWMobile(44)}vw;
  border-radius: 50%;
  padding: ${toVWMobile(13)}vw;
  transition: 0.2s ease-in-out;
  aspect-ratio: 1 / 1;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    width: ${toVWDesktop(44)}vw;
    height: ${toVWDesktop(44)}vw;
    padding: ${toVWDesktop(13)}vw;
  }
`;

export const Icon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: 0.2s ease-in-out;
`;

export const MobileScrollButtonsContainer = styled.div`
  display: flex;
  gap: ${toVWMobile(12)}vw;
  margin-top: ${toVWMobile(32)}vw;
  padding-inline: ${toVWMobile(16)}vw;
  justify-content: flex-end;
  svg{
    fill:red;
  }

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    justify-content: flex-start;
    padding-inline: 0;
    margin-top: ${toVWDesktop(80)}vw;
    gap: ${toVWDesktop(12)}vw;
    display: none;
  }
`;


export const DesktopScrollButtonsContainer = styled(MobileScrollButtonsContainer)`
  display: none;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    display: flex;
  }
`;


export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toVWMobile(20)}vw;
  overflow-x: hidden;
  margin-top: ${toVWMobile(32)}vw;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    margin-top: 0;
    flex-direction: row;
    gap: ${toVWDesktop(20)}vw;
    flex:258;
  }
  
  & .scroll-container {
    display: flex;
    overflow-x: scroll;
    gap: ${vwMobile(12)};
    padding-inline: ${toVWMobile(16)}vw;
    cursor: grab;
    &:active {
      cursor: grabbing;
    }

    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      gap: ${vwDesktop(20)};
      padding-left: 0;
      padding-right: ${toVWDesktop(100)}vw;
    }
  }
`;

const IMAGE_MARGIN = 80


export const CardImage = styled.img`
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
  transition: margin-top 0.2s ease-in-out;
  margin-top: calc(-1 * var(--image-margin));
`;

export const CardText = styled.p`
  font-size: ${toVWMobile(16)}vw;
  font-weight: 600;
  line-height: 140%;
  padding-bottom: ${toVWMobile(24)}vw;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    font-size: ${toVWDesktop(18)}vw;
    padding-bottom: ${toVWDesktop(28)}vw;
  }
`;

export const CardTitleLine = styled.span`
  width: fit-content;
  position: relative;
  
  &:first-child {
    margin-bottom: 0;

    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      margin-bottom: ${toVWDesktop(3)}vw;
    }
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 2px;
    width: 100%;
    background-color: currentColor;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.2s ease-in-out;
  }
`

export const CardLowerContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  width: 100%;
  height: inherit;
`

export const InteractiveContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const CardTitle = styled.h3`
  font-size: ${toVWMobile(16)}vw;
  font-weight: 900;
  line-height: 104%;
  letter-spacing: ${toVWMobile(0.9)}vw;
  transition: 0.2s ease-in-out;
  transform-origin: left;
  text-transform: uppercase;
  display:flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    font-size: ${toVWDesktop(20)}vw;
    letter-spacing: ${toVWDesktop(1.2)}vw;
  }
`;

export const Card = styled.a<{ backgroundColor?: string, hoverBackgroundColor?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${toVWMobile(24)}vw;
  padding: ${toVWMobile(24)}vw;
  padding-top: 0;
  width: 100%;
  min-width: ${toVWMobile(300)}vw;
  max-width: ${toVWMobile(300)}vw;
  color: var(--color-white);
  text-decoration: none;
  background-color: ${(props) => props.backgroundColor};
  --image-margin: ${toVWMobile(IMAGE_MARGIN)}vw;
  margin-top: ${toVWMobile(IMAGE_MARGIN)}vw;
  transition: 0.2s ease-in-out;
  scroll-snap-align: start;
  flex-shrink: 0;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    min-width: ${toVWDesktop(400)}vw;
    max-width: ${toVWDesktop(400)}vw;
    gap: ${toVWDesktop(28)}vw;
    padding: ${toVWDesktop(40)}vw;
    padding-top: 0;
    --image-margin: ${toVWDesktop(IMAGE_MARGIN)}vw;
    margin-top: ${toVWDesktop(IMAGE_MARGIN)}vw;

    &:hover, &:focus-visible{
      margin-top: ${toVWDesktop(1.5 * IMAGE_MARGIN)}vw;
      --image-margin: ${toVWDesktop(1.5 * IMAGE_MARGIN + 20)}vw;
      padding-top: ${toVWDesktop(20)}vw;
      background-color: ${(props) => props.hoverBackgroundColor};
      color: ${(props) => props.backgroundColor};

      ${CardTitleLine}::after {
        transform: scaleX(1);
      }

      ${Icon} {
        scale: 0.8;
      }
    }
  }
`;